import React, { useState, useEffect } from 'react';
import './MentionAutocomplete.css';

const MentionAutocomplete = ({ value, onSelect, participants, position }) => {
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    // Extract the current word being typed after @
    const cursorPos = value.length;
    const textBeforeCursor = value.substring(0, cursorPos);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');

    if (lastAtIndex !== -1) {
      const query = textBeforeCursor.substring(lastAtIndex + 1);
      
      // Only show if there's no space after @ (still typing username)
      if (!query.includes(' ')) {
        const filtered = participants.filter(user =>
          user.username.toLowerCase().startsWith(query.toLowerCase())
        );
        setFilteredUsers(filtered.slice(0, 5)); // Show max 5 results
      } else {
        setFilteredUsers([]);
      }
    } else {
      setFilteredUsers([]);
    }
  }, [value, participants]);

  useEffect(() => {
    setSelectedIndex(0);
  }, [filteredUsers]);

  const handleSelect = (user) => {
    if (onSelect) {
      onSelect(user);
    }
  };

  const handleKeyDown = (e) => {
    if (filteredUsers.length === 0) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => (prev + 1) % filteredUsers.length);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => (prev - 1 + filteredUsers.length) % filteredUsers.length);
        break;
      case 'Enter':
      case 'Tab':
        e.preventDefault();
        handleSelect(filteredUsers[selectedIndex]);
        break;
      case 'Escape':
        setFilteredUsers([]);
        break;
    }
  };

  // Attach keyboard handler to document
  useEffect(() => {
    if (filteredUsers.length > 0) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [filteredUsers, selectedIndex]);

  if (filteredUsers.length === 0) return null;

  return (
    <div className="mention-autocomplete" style={position}>
      {filteredUsers.map((user, index) => (
        <div
          key={user._id}
          className={`mention-item ${index === selectedIndex ? 'selected' : ''}`}
          onClick={() => handleSelect(user)}
          onMouseEnter={() => setSelectedIndex(index)}
        >
          <div className="mention-avatar">
            {user.profile?.avatar?.url ? (
              <img src={user.profile.avatar.url} alt={user.username} />
            ) : (
              <div className="avatar-placeholder">
                {user.username[0].toUpperCase()}
              </div>
            )}
          </div>
          <div className="mention-info">
            <div className="mention-username">@{user.username}</div>
            {user.accountType && (
              <div className="mention-account-type">{user.accountType}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MentionAutocomplete;
